import { useEffect, useState } from "react";
import { EditVideo } from "./EditVideo";
import { S3 } from "../../../../../../constants";

import submit from "submit-form";
import SvgIcon from "../../../../../../parts/SvgIcon";
import AddEditPlaylistVideo from "./AddEditPlaylistVideo";
import EditPlaylistInfo from "./EditPlaylistInfo";

const youtubeRegex =
  /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;

const youtubeLongRegex =
  /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[^&\s\?]+(?!\S))\/)|(?:\S*v=|v\/)))([^&\s\?]+)/;

const URL_REGEX =
  /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

export const EditPlaylist = ({
  nameProps = "",
  descriptionProps = "",
  imageProps = {},
  idProps = "",
  videosProps = [],
  setPlaylistEditFormState,
  playListEditFormState,
  locals,
  handleDeletePlaylist,
  WidgetToggle,
}) => {
  const { origin } = locals;
  //state to control if the playlist are in "change order" mode or not
  const [statusState, setStatusState] = useState("initial");
  //control if the "add playlist" section is opened or not
  const [addNewState, setAddNewState] = useState(false);
  //create video's state
  const [videoFormState, setVideoFormState] = useState({
    name: "",
    url: "",
  });
  //state to show the information
  const [playlistInformation, setPlaylistInformation] = useState({
    name: nameProps,
    description: descriptionProps,
    id: idProps,
    videos: videosProps,
    image: imageProps,
  });
  //state to store al the videos
  const [videosState, setvideosState] = useState(playlistInformation.videos);
  const [isInformationTab, setIsInformationTab] = useState(false);
  //render the current information
  useEffect(() => {
    if (locals.videoPlaylists) {
      const findPlaylist = locals.videoPlaylists.find(
        ({ _id }) => _id === idProps
      );
      if (
        findPlaylist.name !== nameProps ||
        findPlaylist.description !== descriptionProps ||
        findPlaylist.image !== imageProps
      ) {
        setPlaylistInformation({
          name: findPlaylist.name,
          description: findPlaylist.description,
          id: findPlaylist._id,
          videos: findPlaylist.videos,
          image: findPlaylist.image,
        });
      }
      setvideosState(findPlaylist.videos);
    }
  }, [locals.videoPlaylists]);

  /**
   * Validate if the video's form is valid (if it is not a white text, if it is a valid url and if it is a valid youtube link)
   * @returns
   */
  const validationVideoSubmit = () => {
    if (
      videoFormState.url.length > 0 &&
      URL_REGEX.test(videoFormState.url) &&
      videoFormState.name.length > 0 &&
      ((videoFormState.url.includes("youtube") &&
        videoFormState.url.includes("shorts")) ||
        youtubeLongRegex.test(videoFormState.url))
    ) {
      return true;
    }
    return false;
  };

  /**
   * Refresh the page deleting the id playlist query
   */
  const handleRefresh = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { playlistid: "", submited: "", created: "", edited: "" },
    });
  };

  /**
   * Assign the value of the create video's state
   * @param {*} param0
   */
  const handleInputVideoChange = ({ target }) => {
    const newState = Object.assign({}, videoFormState, {
      [target.name]: target.value,
    });
    setVideoFormState(newState);
  };

  /**
   * Create a video
   * @param {*} e
   */
  const handleVideoSubmit = (e) => {
    e.preventDefault();
    setAddNewState(false);
    setVideoFormState({ name: "", url: "" });

    const body = [];
    if (playListEditFormState.videos.length > 0) {
      playListEditFormState.videos.forEach((element) => {
        body.push(element);
      });
    }
    body.push(videoFormState);

    const newState = Object.assign({}, playListEditFormState, {
      videos: body,
    });
    setPlaylistEditFormState(newState);

    submit(`/actions/video-playlist/save/${playListEditFormState.id}`, {
      method: "POST",
      body: { videos: body },
    });
  };

  /**
   * Reorder
   * @param {*} e
   */
  const handleSaveReorderPlayLists = (e) => {
    e.preventDefault();

    submit(`/actions/video-playlist/save/${playlistInformation.id}`, {
      method: "POST",
      body: { videos: videosState },
    });
    setStatusState("initial");
  };
  const cancelReorder = () => {
    // window.location.href = `${origin}/coaching-portal/widgets?widget=${activeWidget._id}`;
    window.location.href = `${origin}/coaching-portal/widgets`;
  };
  const openForm = () => {
    setAddNewState(true);
  };

  return (
    <>
      <header className="edit-playlist">
        <hgroup>
          <SvgIcon
            src={"/img/new-icons/back-button.svg"}
            onClickFn={() => {
              setPlaylistEditFormState({
                name: "",
                description: "",
                widget: "",
                image: {},
                id: "",
                status: "draft",
                videos: [],
              });
              handleRefresh();
            }}
          />
          <h4>{playlistInformation.name}</h4>
        </hgroup>
        <hgroup>
          {/* <div className="btn-switch">Publish {WidgetToggle}</div> */}
          <button
            data-button-type="secondary"
            data-action="cancel"
            onClick={(e) => handleDeletePlaylist(e, playlistInformation.id)}
            type="button"
          >
            Delete
          </button>
          {statusState === "initial" ? (
            <button
              data-button-type="secondary"
              onClick={() => setStatusState("change-order")}
            >
              Change Order
            </button>
          ) : (
            <>
              <button
                data-button-type="primary"
                onClick={handleSaveReorderPlayLists}
              >
                Save
              </button>
              <button
                data-button-type="secondary"
                data-action="cancel"
                onClick={cancelReorder}
              >
                Cancel
              </button>
            </>
          )}
        </hgroup>
      </header>
      <article className="edit-playlist-wrapper">
        <nav role="tablist">
          <a
            onClick={() => setIsInformationTab(false)}
            aria-current={!isInformationTab ? true : undefined}
          >
            Videos
          </a>
          <a
            onClick={() => setIsInformationTab(true)}
            aria-current={isInformationTab ? true : undefined}
          >
            Information
          </a>
        </nav>

        {isInformationTab ? (
          <EditPlaylistInfo playlist={playlistInformation} />
        ) : (
          <>
            <div className="principal-grabber-edit-div">
              {videosState.map(({ name, url }, index) => {
                return (
                  <EditVideo
                    key={JSON.stringify({ name, url })}
                    id={JSON.stringify({ name, url })}
                    nameProps={name}
                    urlProps={url}
                    _indexProps={index}
                    allVideos={videosState}
                    setvideosState={setvideosState}
                    playlist={idProps}
                    setPlaylistEditFormState={setPlaylistEditFormState}
                    playListEditFormState={playListEditFormState}
                    statusStateProps={statusState}
                  />
                );
              })}
            </div>
            {/* show add new videos */}
            <footer>
              {!addNewState ? (
                <div className="dashed-box" onClick={openForm}>
                  <SvgIcon
                    src="/img/new-icons/add-square-outline.svg"
                    alt="back"
                  />
                  <p className="p4">Add new video</p>
                </div>
              ) : (
                <AddEditPlaylistVideo
                  videoFormState={videoFormState}
                  handleInputVideoChange={handleInputVideoChange}
                  validationVideoSubmit={validationVideoSubmit}
                  handleVideoSubmit={handleVideoSubmit}
                  setAddNewState={setAddNewState}
                />
              )}
            </footer>
          </>
        )}
        {/* show the videos */}
      </article>
    </>
  );
};
